/**
 * Versioned URLs for the artwork in public/wallet/.
 *
 * These files are edited in place (the client-supplied originals carried a
 * "Made with AI" badge, which was painted out). Same path + same filename
 * means browsers - and any CDN sitting in front of the site - keep serving
 * the copy they already have, so an old image can survive a deploy. The
 * query string changes the URL, which is what actually forces a refetch.
 *
 * Bump WALLET_ART_VERSION whenever a file in public/wallet/ is edited in
 * place without being renamed.
 */
export const WALLET_ART_VERSION = "2";

export function walletArt(file: string): string {
  return `/wallet/${file}?v=${WALLET_ART_VERSION}`;
}
